import type { MfaMethod } from './types';

const METHOD_COPY: Record<
  MfaMethod,
  {
    sent: string;
    checkHeading: string;
    switchLabel: string;
    mask: (hint: string) => string;
  }
> = {
  sms: {
    sent: 'texted',
    checkHeading: 'Check your phone',
    switchLabel: 'Text me instead',
    mask: (hint) => `•••• ${hint}`,
  },
  email: {
    sent: 'emailed',
    checkHeading: 'Check your email',
    switchLabel: 'Email me instead',
    mask: (hint) => hint,
  },
};

export const codeSentMessage = ({
  method,
  hint,
}: {
  method: MfaMethod;
  hint: string;
}): string =>
  `We ${METHOD_COPY[method].sent} a code to ${METHOD_COPY[method].mask(hint)}.`;

export const checkHeading = (method: MfaMethod): string =>
  METHOD_COPY[method].checkHeading;

export const switchLabel = (method: MfaMethod): string =>
  METHOD_COPY[method].switchLabel;

export const alternativeMethod = ({
  method,
  methods,
}: {
  method: MfaMethod;
  methods: readonly MfaMethod[];
}): MfaMethod | undefined => methods.find((candidate) => candidate !== method);

export const secondsUntil = (iso: string): number => {
  const timestamp = Date.parse(iso);
  return Number.isNaN(timestamp)
    ? 0
    : Math.max(0, Math.ceil((timestamp - Date.now()) / 1000));
};

export const resendLabel = (seconds: number, blocked: boolean): string => {
  if (blocked) return 'Resend unavailable';
  return seconds > 0 ? `Resend code in ${seconds}s` : 'Resend code';
};
